import type { IAvatarAccessory, IAvatarElement } from '../types';

const HEADSCARVES = new Set([
  'Hair_Headscarf',
  'Hair_HeadscarfAlt1',
  'Hair_HeadscarfAlt2',
  'Hair_HeadscarfAlt3',
  'Hair_HeadscarfAlt4',
  'Hair_HeadscarfAlt5'
]);

const TURBANS = new Set([
  'Hair_Turban',
  'Hair_TurbanAlt2',
  'Hair_TurbanAlt3',
  'Hair_TurbanAlt4',
  'Hair_TurbanAlt5'
]);

const SCARVES = new Set([
  'Hair_HeadscarfAlt3',
  'Hair_HeadscarfAlt4',
  'Hair_HeadscarfAlt5',
  'Hair_Turban',
  'Hair_TurbanAlt2',
  'Hair_TurbanAlt3',
  'Hair_TurbanAlt4',
  'Hair_TurbanAlt5'
]);

const FACES_WITHOUT_BEARD = new Set([
  'Face_Eyebrow1',
  'Face_Eyebrow2',
  'Face_Eyebrow3',
  'Face_Eyebrow4',
  'Face_Eyebrow5'
]);

const KANDOORA = new Set([
  'Shirt_Kandoora',
  'Shirt_KandooraAlt1',
  'Shirt_KandooraAlt2'
]);

const LONG_SLEEVES = new Set([
  'Shirt_Andersen',
  'Shirt_MLK',
  'Shirt_Amalia',
  'Shirt_Einstein',
  'Shirt_Backpack',
  'Shirt_Scarf',
  'Shirt_Sweater',
  'Shirt_Sweatertop',
  'Shirt_Abaya',
  'Shirt_AbayaAlt1',
  'Shirt_AbayaAlt2',
  'Shirt_Kandoora',
  'Shirt_KandooraAlt1',
  'Shirt_KandooraAlt2',
  'Shirt_Hoodie2',
  'Shirt_Hoodie3'
]);

const LONG_PANTS = new Set([
  'Pants_Dress',
  'Pants_Tightdress',
  'Pants_Simple',
  'Pants_SimpleCrocks',
  'Pants_Rollerskates',
  'Pants_OversizedPants',
  'Pants_OversizedJeans',
  'Pants_FemalePants1',
  'Pants_FemalePants2',
  'Pants_FemalePants3',
  'Pants_FemalePants4'
]);

const ALLOWED_BY_KIND = {
  shirt: LONG_SLEEVES,
  pants: LONG_PANTS
} as const;

const hasScarf = (elements: IAvatarElement[] = []) =>
  elements.some(({ name }) => SCARVES.has(name));

export const filterFaceForScarf = (
  list: IAvatarAccessory[],
  elements: IAvatarElement[] = []
) =>
  elements.some(({ name }) => HEADSCARVES.has(name))
    ? list.filter(({ name }) => FACES_WITHOUT_BEARD.has(name))
    : list;

export const filterHairForScarf = (
  list: IAvatarAccessory[],
  elements: IAvatarElement[] = []
) => {
  const face = elements.find(({ name }) => name.startsWith('Face_'))?.name;
  const shirt = elements.find(({ name }) => name.startsWith('Shirt_'))?.name;
  const pants = elements.find(({ name }) => name.startsWith('Pants_'))?.name;

  if (face && !FACES_WITHOUT_BEARD.has(face)) {
    list = list.filter(({ name }) => !HEADSCARVES.has(name));
  }

  if (shirt && shirt !== 'Shirt_OversizedShirt3') {
    if (!KANDOORA.has(shirt)) {
      list = list.filter(({ name }) => !TURBANS.has(name));
    }
    if (!LONG_SLEEVES.has(shirt)) {
      list = list.filter(({ name }) => !HEADSCARVES.has(name));
    }
  }

  if (pants && pants !== 'Pants_Empty' && !LONG_PANTS.has(pants)) {
    list = list.filter(({ name }) => !SCARVES.has(name));
  }

  return list;
};

export const filterOutfitForScarf = (
  list: IAvatarAccessory[],
  kind: keyof typeof ALLOWED_BY_KIND,
  elements: IAvatarElement[] = []
) => {
  if (kind === 'shirt') {
    if (elements.some(({ name }) => TURBANS.has(name))) {
      return list.filter(({ name }) => KANDOORA.has(name));
    }
    if (elements.some(({ name }) => HEADSCARVES.has(name))) {
      return list.filter(({ name }) => LONG_SLEEVES.has(name));
    }
    return list;
  }

  return hasScarf(elements)
    ? list.filter(({ name }) => ALLOWED_BY_KIND[kind].has(name))
    : list;
};
